import {
  strftime,
  formatTime,
  isToday,
  isTomorrow,
  isWithinWeek,
  adjustNextDayOfWeek,
} from 'util/date'

export const SNOOZED_INDEFINITELY = 'SNOOZED_INDEFINITELY'

export function snoozeLabel(snoozedUntil) {
  if (snoozedUntil === SNOOZED_INDEFINITELY) return 'Indefinitely'
  const time = formatTime(snoozedUntil)

  let label

  if (isToday(snoozedUntil)) {
    label = `Today, ${time}`
  } else if (isTomorrow(snoozedUntil)) {
    label = `Tomorrow, ${time}`
  } else if (isWithinWeek(snoozedUntil)) {
    const day = new Date(snoozedUntil).toLocaleDateString('en-US', {
      weekday: 'long',
    })
    label = `${day}, ${time}`
  } else {
    const date = strftime('%b %Do', snoozedUntil)
    label = `${date}, ${time}`
  }

  return label
}

const setHours = hours => timestamp => {
  const date = new Date(timestamp)
  date.setHours(hours, 0, 0, 0)
  return date.getTime()
}

const adjustDays = daysDiff => timestamp => {
  const date = new Date(timestamp)
  date.setDate(date.getDate() + daysDiff)
  return date.getTime()
}

const nextDay = adjustDays(1)

export const OPTIONS = [
  {
    value: '4-hours',
    text: '4 hours',
    format: timestamp => `${strftime('%l:%M%p', timestamp)}`,
    timestamp: () => Date.now() + 4 * 60 * 60 * 1000,
  },
  {
    value: 'tomorrow-morning',
    text: 'Tomorrow Morning',
    format: timestamp => `${strftime('%l%p', timestamp)}`,
    timestamp: () => setHours(8)(nextDay(Date.now())),
  },
  {
    value: 'tomorrow-afternoon',
    text: 'Tomorrow Afternoon',
    format: timestamp => `${strftime('%l%p', timestamp)}`,
    timestamp: () => setHours(13)(nextDay(Date.now())),
  },
  {
    value: '2-days',
    text: '2 Days',
    format: timestamp => `${strftime('%A @ %l%p', timestamp)}`,
    timestamp: () => adjustDays(2)(setHours(8)(Date.now())),
  },
  {
    value: '4-days',
    text: '4 Days',
    format: timestamp => `${strftime('%A @ %l%p', timestamp)}`,
    timestamp: () => adjustDays(4)(setHours(8)(Date.now())),
  },
  {
    value: 'next-monday',
    text: 'Next Monday',
    format: timestamp => `${strftime('%A @ %l%p', timestamp)}`,
    timestamp: () => adjustNextDayOfWeek(1)(setHours(8)(Date.now())),
  },
  {
    value: '1-week',
    text: '1 Week',
    format: timestamp => `${strftime('%A %Do @ %l%p', timestamp)}`,
    timestamp: () => adjustDays(7)(setHours(8)(Date.now())),
  },
  {
    value: '2-weeks',
    text: '2 Weeks',
    format: timestamp => `${strftime('%A %Do @ %l%p', timestamp)}`,
    timestamp: () => adjustDays(14)(setHours(8)(Date.now())),
  },
  {
    value: '30-days',
    text: '1 Month',
    format: timestamp => `${strftime('%b %Do @ %l%p', timestamp)}`,
    timestamp: () => adjustDays(30)(setHours(8)(Date.now())),
  },
  {
    value: SNOOZED_INDEFINITELY,
    text: 'Indefinitely',
    format: () => 'until unsnoozed',
    timestamp: () => SNOOZED_INDEFINITELY,
    indefinite: true,
  },
]
